import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c3hepkjc1t: FaireBrandEntity = {
  token: "b_c3hepkjc1t",
  type: "brand",
  name: "Nopalera",
  avatarUrl:
    "https://cdn.faire.com/fastly/22eac98db5671bd758bb622678729186714f51880eee4ff2e81f5d64f3f20dbf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/67ca1c97a57cf764c0c9e457d08e434a8147fe6294011832d9376d3df69f8621.png",
  logoUrl:
    "https://cdn.faire.com/fastly/22eac98db5671bd758bb622678729186714f51880eee4ff2e81f5d64f3f20dbf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67ca1c97a57cf764c0c9e457d08e434a8147fe6294011832d9376d3df69f8621.png",
  location: " San Antonio, TX, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 60,
  isTopShop: true,
  isInsider: true,
  description:
    "Nopalera was founded to elevate and celebrate Latin@ culture.\n\nOur products are inspired by the beauty and richness of Mexico. We take our inspiration from the nopal cactus, an ancient symbol of Mexican culture and one of the most sustainable, nourishing, and versatile plants in the world. You can eat it, make textiles from it, and use it to hydrate your skin and hair.\n\nIt is strong, resilient, beautiful, and has always been here.\n\nJust like us. ",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:54.932Z",
    importedBy: "entity-db-cli",
  },
};
